import React from 'react'
import { withTranslation } from 'react-i18next'
import LessonsDropdown from '../../components/Study/LessonsDropdown.jsx'
import { CaretRight, CaretDown } from "phosphor-react"
import PropTypes from 'prop-types'

class StudyCard extends React.Component {
    constructor(props) {
        super(props)
        this.switchIcon = this.switchIcon.bind(this)
    }

    switchIcon(dropdownId) {
        const dropdown = document.querySelector(dropdownId)
        const open = dropdown.querySelector("#open")
        const close = dropdown.querySelector("#close")
        if (open.classList.contains('active')) {
            open.classList.remove('active')
            open.classList.add('d-none')
            close.classList.remove('d-none')
            close.classList.add('active')
        } else {
            close.classList.remove('active')
            close.classList.add('d-none')
            open.classList.remove('d-none')
            open.classList.add('active')
        }
    }

    render() {
        // const { t } = this.props
        return (
            <div className="lesson-dropdown">
                <a className="lesson-dropdown-title" data-toggle="collapse" href={`#lesson-dropdown-id-${this.props.id}`} role="button" aria-expanded="false" id={`lesson-dropdown-id-${this.props.id}`} aria-controls={`lesson-dropdown-id-${this.props.id}`} onClick={() => this.switchIcon(`#lesson-dropdown-id-${this.props.id}`)}>
                    <span className="text md-font-size">{this.props.title}</span>
                    <CaretRight size={16} className="active dropdown-icon" id="open" />
                    <CaretDown size={16} className="d-none dropdown-icon" id="close" />
                </a>
                <div className="collapse lesson-dropdown-items" id={`lesson-dropdown-id-${this.props.id}`}>
                    {this.props.modules.map((mod) => (
                        <LessonsDropdown key={mod.id}
                            id={mod.id}
                            title={mod.title}
                            type={mod.type}
                            available={mod.available}
                            complete={mod.complete}
                            active={this.props.modId === mod.id ? true : false}
                            index={mod.number}
                            courseId={this.props.courseId}
                            props={this.props}
                        />
                    ))}
                </div>
                <hr className="m-0" />
            </div>
        )
    }
}

StudyCard.propTypes = {
    t: PropTypes.func,
    title: PropTypes.string,
    modules: PropTypes.array,
    id: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    courseId: PropTypes.string,
    modId: PropTypes.number,
    themeIndex: PropTypes.number,
}

export default withTranslation()(StudyCard)



// WEBPACK FOOTER //
// ./src/components/Study/Lessons.jsx